<template>
    <span>
        <editarevento></editarevento>
    </span>
</template>

<script>
import Editarevento from '@/components/Editar-Evento';

export default {
    name: 'cadeditarevento',
    components: {
        Editarevento
    }
};
</script>